// extracted by mini-css-extract-plugin
export default {"status":"CompletionStatus_status__wNY2O"};